import { constants } from './constants';
import PptxGenJS from 'pptxgenjs';
import { parseMarkdownContent } from './markdown/markdownModule';
import { addTextToSlide } from './addTextToSlide';
import { addTableToSlide } from './addTableToSlide';
import { SlideWithCurrentPositionY } from './interfaces';

export const createPPTXSlide = async (
    pptx: PptxGenJS,
    markdownContent: string,
    slideDimensions: { width: number; height: number }
) => {
    const position = { x: constants.INITIAL_POSITION_X, y: constants.INITIAL_POSITION_Y + constants.TEXT_MARGIN };
    const { elements } = await parseMarkdownContent(markdownContent);
    elements.sort((a, b) => a.order - b.order);
    let textObjects: PptxGenJS.TextProps[] = [];
    let slide: SlideWithCurrentPositionY = { positionY: position.y, slide: pptx.addSlide() };

    for (const element of elements) {
        if (element.type === 'text') {
            textObjects.push(element.content);
        } else {
            if (textObjects.length > 0) {
                position.y = slide.positionY;
                slide = addTextToSlide(pptx, textObjects, position, slideDimensions.width, slide.slide);
                textObjects = [];
                position.y = slide.positionY + constants.TEXT_MARGIN;
            }

            slide = processNonTextElement(pptx, slide.slide, element, position.y, position, slideDimensions);
            position.y = slide.positionY;
        }
    }

    if (textObjects.length > 0) {
        position.y = slide.positionY;
        slide = addTextToSlide(pptx, textObjects, position, slideDimensions.width, slide.slide);
        slide.positionY = slide.positionY + constants.TEXT_MARGIN;
    }
}

const processNonTextElement = (
    pptx: PptxGenJS,
    slide: PptxGenJS.Slide,
    element: any,
    currentY: number,
    position: { x: number; y: number },
    slideDimensions: { width: number; height: number }
): SlideWithCurrentPositionY => {
    const elementProcessors: { [key: string]: Function } = {
        table: processTableElement,
        image: processImageElement,
    };
    const processor = elementProcessors[element.type];

    return processor ? processor(pptx, slide, element, currentY, position, slideDimensions) : { slide, positionY: currentY };
}

const processTableElement = (
    pptx: PptxGenJS,
    slide: PptxGenJS.Slide,
    element: any,
    currentY: number,
    position: { x: number; y: number },
    slideDimensions: { width: number; height: number }
): SlideWithCurrentPositionY => {
    if (currentY > slideDimensions.height / 2) {
        slide = pptx.addSlide();
        currentY = constants.INITIAL_POSITION_Y + constants.TEXT_MARGIN;
    } else if (currentY > constants.INITIAL_POSITION_Y + constants.TEXT_MARGIN) {
        currentY += constants.TEXT_MARGIN;
    }

    const rows = element.content.rows;
    const fontSize = constants.DEFAULT_FONT_SIZE;
    const lineHeight = fontSize * constants.POINT_TO_INCH_FACTOR * constants.LINE_HEIGHT_FACTOR_TABLE;
    const maxLineLength = constants.LINE_LENGTH_TABLE_FACTOR / fontSize;
    const maxHeight = slideDimensions.height - constants.BOTTOM_MARGIN;

    let currentSlide = slide;
    let currentRows: any[][] = [];
    let accumulatedHeight = 0;

    for (const row of rows) {
        let maxRowLines = 1;

        for (const cell of row) {
            let text: string = '';

            if (typeof cell === 'string') {
                text = cell;
            } else if (typeof cell === 'object' && cell !== null && 'text' in cell) {
                text = String(cell.text);
            }

            const lines = text
                .split('\n')
                .map((line: string) => Math.ceil(line.length / maxLineLength))
                .reduce((sum: number, lineCount: number) => sum + lineCount, 0);

            if (lines > maxRowLines) {
                maxRowLines = lines;
            }
        }

        const rowHeight = maxRowLines * lineHeight;
       

        if (currentY + accumulatedHeight + rowHeight > maxHeight && currentRows.length > 0) {
            addTableToSlide(pptx,currentSlide, { rows: currentRows }, { x: position.x, y: currentY }, slideDimensions);
            currentSlide = pptx.addSlide();
            currentY = constants.INITIAL_POSITION_Y + constants.TEXT_MARGIN;
            currentRows = [];
            accumulatedHeight = 0;
        }

        currentRows.push(row);
        accumulatedHeight += rowHeight;
    }
   

    if (currentRows.length > 0) {
        addTableToSlide(pptx,currentSlide, { rows: currentRows }, { x: position.x, y: currentY }, slideDimensions);
    }
const nextY = currentY + accumulatedHeight + 0.3; 
 let targetSlide = currentSlide;
  
  if (nextY > maxHeight - 2) {
    targetSlide = pptx.addSlide();
   
    return {
      slide: targetSlide,
      positionY: 0.5 
    };
  }else{
  return {
    slide: targetSlide,
    positionY: constants.SLIDE_DIMENSIONS.height 
  }
}
};


const processImageElement = (
    pptx: PptxGenJS,
    slide: PptxGenJS.Slide,
    element: any,
    _currentY: number,
    _position: { x: number; y: number },
    slideDimensions: { width: number; height: number }
): SlideWithCurrentPositionY => {
    const imageHeight = element.content.h ?? 3;
    const imageWidth = element.content.w ?? 5;

    const centerX = (slideDimensions.width - imageWidth) / 2;
    const centerY = (slideDimensions.height - imageHeight) / 2;

    slide.addImage({
        ...element.content,
        x: centerX,
        y: centerY,
        w: imageWidth,
        h: imageHeight,
    });

    return {
        slide: slide,
        positionY: constants.INITIAL_POSITION_Y + constants.TEXT_MARGIN,
    };
};
